"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("../../media/icon/Icon");
var _Subheading = _interopRequireDefault(require("../../text/Subheading"));
var _globalTokens = require("../../../shared/global-tokens");
var NavigationMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-navigation-menu"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _Scrollbar = _interopRequireDefault(require("../../layout/scroll/Scrollbar"));
var _Shared = require("./Shared.styled");
var _Item = _interopRequireDefault(require("./Item"));
var _Link = _interopRequireDefault(require("./Link"));
var _Submenu = _interopRequireDefault(require("./Submenu"));
var _Trigger = _interopRequireDefault(require("./Trigger"));
var _jsxRuntime = require("react/jsx-runtime");
var animationTimeInMS = 300;
var OpacityTransition = _styledComponents.default.div.withConfig({
  displayName: "VerticalNavigationBar__OpacityTransition",
  componentId: "sc-1l7ntfa-0"
})(["opacity:", ";transition:opacity ", "ms cubic-bezier(1,0,0,1);"], function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, animationTimeInMS);

// Root menu with styles
var VerticalNavigationBarWrapper = _styledComponents.default.div.withConfig({
  displayName: "VerticalNavigationBar__VerticalNavigationBarWrapper",
  componentId: "sc-1l7ntfa-1"
})(["position:relative;height:100%;z-index:48;"]);
// Component responsible for maintaining the space required by the absolutely positioned Sidebar menu.
// When the Sidebar menu is locked, the SpaceMaintainer will transition to the matching width subsequently, giving a smooth transition experience.
var OverlaySpaceMaintainer = _styledComponents.default.div.withConfig({
  displayName: "VerticalNavigationBar__OverlaySpaceMaintainer",
  componentId: "sc-1l7ntfa-2"
})(["width:", ";height:100%;transition:width ", "ms cubic-bezier(1,0,0,1);"], function (_ref2) {
  var $locked = _ref2.$locked;
  return $locked ? _globalTokens.globalSizing['6400'] : _globalTokens.globalSizing['1100'];
}, animationTimeInMS);
var StyledMenu = (0, _styledComponents.default)(NavigationMenuPrimitive.Root).withConfig({
  displayName: "VerticalNavigationBar__StyledMenu",
  componentId: "sc-1l7ntfa-3"
})(["position:absolute;top:0;left:0;display:flex;flex:0 0 auto;border-right:", " solid ", ";background:", ";width:", ";height:100%;transition:width ", "ms cubic-bezier(1,0,0,1);"], _globalTokens.globalBorder.width.thin, _tokens.default.sky.sys.color.border.decorative, _tokens.default.sky.sys.color.background.neutral['2'], function (props) {
  return props.$expanded ? _globalTokens.globalSizing['6400'] : _globalTokens.globalSizing['1100'];
}, animationTimeInMS);
var StyledScrollbarContent = _styledComponents.default.div.withConfig({
  displayName: "VerticalNavigationBar__StyledScrollbarContent",
  componentId: "sc-1l7ntfa-4"
})(["width:100%;display:flex;overflow:hidden;"]);
var VerticalNavigationBar = function VerticalNavigationBar(_ref3) {
  var children = _ref3.children,
    expanded = _ref3.expanded,
    locked = _ref3.locked,
    open = _ref3.open,
    close = _ref3.close,
    onToggle = _ref3.onToggle,
    maxHeight = _ref3.maxHeight,
    defaultValue = _ref3.defaultValue; // Preserving states for handling of animation timing
  var _ref4 = (0, _react.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    collapsing = _ref5[0],
    setCollapsing = _ref5[1]; // Component is either expanded in the process of transitionin to collapsed
  var expandedOrTransition = expanded || collapsing;

  // effects for maintaining
  (0, _react.useEffect)(function () {
    if (!expanded) {
      setCollapsing(true);
      var animationTimeout = setTimeout(function () {
        return setCollapsing(false);
      }, animationTimeInMS);
      return function () {
        clearTimeout(animationTimeout);
        setCollapsing(false);
      };
    }
  }, [expanded]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(VerticalNavigationBarWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(OverlaySpaceMaintainer, {
      $locked: locked
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMenu, {
      orientation: 'vertical',
      $expanded: expanded,
      defaultValue: defaultValue,
      onMouseLeave: close,
      onMouseEnter: open,
      "data-cy": "vertical-nav",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledScrollbarContent, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Scrollbar.default, {
          maxHeight: maxHeight,
          hideAxis: _Scrollbar.default.Axis.Horizontal,
          hasFocusableContent: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Trigger.default, {
            expanded: expanded,
            onClick: onToggle,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              size: 'm',
              icon: locked ? 'collapseSideBar' : expanded ? 'expand' : 'expandSideBar'
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OpacityTransition, {
              visible: expanded,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Subheading.default, {
                noWrap: true,
                children: expandedOrTransition ? locked ? 'Hide Sidebar' : 'Keep Sidebar Open' : null
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OpacityTransition, {
            visible: expanded,
            children: expandedOrTransition ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shared.StyledList, {
              children: children
            }) : null
          })]
        })
      })
    })]
  });
};
VerticalNavigationBar.Item = _Item.default;
VerticalNavigationBar.Link = _Link.default;
VerticalNavigationBar.SubMenu = _Submenu.default;
var _default = exports.default = VerticalNavigationBar;